document.addEventListener("DOMContentLoaded", function () {
  const materialButtons = document.querySelectorAll(".custom-swatch-mate-btn");
  const sizeContainer = document.querySelector(".custom-swatch-size-buttons");
  const sizeButtons = document.querySelectorAll(".custom-size-btn");
  const selectedMaterialText = document.getElementById("selected-material-text");
  const selectedSizeText = document.getElementById("selected-size-text");

  function updateSelectedSwatchImage() {
    const activeSizeButton = document.querySelector(".custom-size-btn.active");
    if (activeSizeButton) {
      const selectedImage = activeSizeButton.getAttribute("data-image-selected");
      const defaultImage = activeSizeButton.getAttribute("data-image");
      const imgElement = activeSizeButton.querySelector(".custom-size-image");

      if (selectedImage && selectedImage !== "null") {
        imgElement.src = selectedImage;
      } else {
        imgElement.src = defaultImage;
      }
    }
  }

  function applyInitialBorderColor() {
    const activeButton = document.querySelector(".custom-swatch-mate-btn.active");
    if (activeButton) {
      const selectedBorderColor = activeButton.getAttribute("data-border-color");
      activeButton.style.borderColor = selectedBorderColor;
    }
  }

  materialButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const selectedMaterial = this.getAttribute("data-material");
      const selectedBorderColor = this.getAttribute("data-border-color");

      selectedMaterialText.textContent = selectedMaterial;

      materialButtons.forEach((btn) => {
        btn.classList.remove("active");
        btn.style.borderColor = "transparent";
      });
      this.classList.add("active");
      this.style.borderColor = selectedBorderColor;

      updateSizeSwatches(selectedMaterial);
      sizeContainer.classList.remove("custom-hidden");
    });
    applyInitialBorderColor();
  });

  function updateSizeSwatches(selectedMaterial) {
    sizeButtons.forEach((button) => {
      if (button.getAttribute("data-material") === selectedMaterial) {
        button.classList.remove("custom-hidden");
      } else {
        button.classList.add("custom-hidden");
      }
    });
  }

  const currentProductId = document.querySelector(".custom-size-btn.active")?.getAttribute("data-product-id");

  sizeButtons.forEach((button) => {
    const productId = button.getAttribute("data-product-id");
    const isActive = productId === currentProductId;

    if (isActive) {
      button.classList.add("active");
    } else {
      button.classList.remove("active");
    }
  });

  async function getProductHandle(productId) {
    try {
      console.log("Fetching handle for product ID:", productId);

      const query = `
        {
          product(id: "gid://shopify/Product/${productId}") {
            handle
          }
        }
      `;

      const response = await fetch('/api/2025-07/graphql.json', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "8ec9f27163460f17335fae269d32142d"
        },
        body: JSON.stringify({ query })
      });

      const data = await response.json();

      if (data.data.product) {
        console.log("Product handle found:", data.data.product.handle);
        return data.data.product.handle;
      } else {
        console.warn("No product handle found for ID:", productId);
        console.warn(data);
        return null;
      }
    } catch (error) {
      console.error("Error occured.:", error);
      return null;
    }
  }

  sizeButtons.forEach((button) => {
    button.addEventListener("click", async function () {
      const productId = this.getAttribute("data-product-id");
      const selectedSize = this.getAttribute("data-size");
      const selectedImage = this.getAttribute("data-image-selected");
      const defaultImage = this.getAttribute("data-image");

      selectedSizeText.textContent = selectedSize;

      console.log("Fetching product handle for ID:", productId);
      const productHandle = await getProductHandle(productId);

      sizeButtons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");

      const imgElement = this.querySelector(".custom-size-image");
      if (selectedImage && selectedImage !== "null") {
        imgElement.src = selectedImage;
      } else {
        imgElement.src = defaultImage;
      }

      updateSelectedSwatchImage();

      if (productHandle) {
        window.location.href = `/products/${productHandle}`;
      } else {
        alert("Error");
      }
    });

    button.addEventListener("mouseenter", function () {
      const hoverImage = this.getAttribute("data-image-selected");
      const imgElement = this.querySelector(".custom-size-image");

      if (hoverImage && hoverImage !== "null") {
        imgElement.src = hoverImage;
      }
    });

    button.addEventListener("mouseleave", function () {
      const imgElement = this.querySelector(".custom-size-image");

      if (this.classList.contains("active")) {
        const selectedImage = this.getAttribute("data-image-selected");
        if (selectedImage && selectedImage !== "null") {
          imgElement.src = selectedImage;
        }
      } else {
        const defaultImage = this.getAttribute("data-image");
        if (defaultImage) {
          imgElement.src = defaultImage;
        }
      }
    });

    button.addEventListener("click", function () {
      sizeButtons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");

      const selectedImage = this.getAttribute("data-image-selected");
      const imgElement = this.querySelector(".custom-size-image");
      if (selectedImage && selectedImage !== "null") {
        imgElement.src = selectedImage;
      }
    });
  });

  updateSelectedSwatchImage();
  
  const activeMaterialButton = document.querySelector(".custom-swatch-mate-btn.active");
  if (activeMaterialButton) {
    updateSizeSwatches(activeMaterialButton.getAttribute("data-material"));
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const swatches = document.querySelectorAll(".swatch-label");

  swatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {
      const selectedColor = this.querySelector(".swatch-color").style.getPropertyValue("--swatch-background");

      swatches.forEach((btn) => btn.classList.remove("active"));

      this.classList.add("active");

      this.querySelector(".swatch-color").style.borderColor = selectedColor;
    });
  });
});